import * as R from 'ramda'

import { getLanguages } from 'utils/languages'

export const mapInternalStateToPayload = state => {
  const { email, language, name, phone } = state ?? {}

  return {
    language: R.prop('value', language),
    email,
    name,
    phone,
  }
}

export const mapCandidateToInternalState = state => {
  const { email, language, name, phone } = state ?? {}

  return {
    language: R.find(R.propEq('value', language), getLanguages()),
    email,
    name,
    phone,
  }
}
